import { Component, OnInit } from '@angular/core';
import { TimelineService } from 'src/app/services/timeline.service';
import { AppComponent } from 'src/app/app.component';
import { ModalController } from '@ionic/angular';
import { AccountPage } from '../account/account.page';

@Component({
  selector: 'app-accounts-list',
  templateUrl: './accounts-list.page.html',
  styleUrls: ['./accounts-list.page.scss'],
})
export class AccountsListPage implements OnInit {
  modal;

  constructor(private modalCtrl:ModalController, public modalController:ModalController, public timelineService:TimelineService) { }

  
  ngOnInit() {


    console.log('-roomersList ', this.timelineService.roomersList)

    this.timelineService.roomersListPlayers = [];

    for (let index = 0; index < this.timelineService.roomersList.length; index++) 
    {
      const element = this.timelineService.roomersList[index];
      console.log('-roomer name', element.name);

      let player:any = {};

      player.imageURL = element.getVariable('image').value;
      player.userId = element.name;
      player.masculin = element.getVariable('masculin').value;
      player.outlook = element.getVariable('outlook').value;
      player.type = element.getVariable('type').value;
      //let imageTypeURL = this.timelineService.getMyType(type);
      
      player.strength = this.timelineService.getStrength(element.getVariable('strength').value, player.masculin);
      player.dexternity = this.timelineService.getDexternity(element.getVariable('dexternity').value, player.masculin);
      player.initiative = this.timelineService.getInitiative(element.getVariable('initiative').value, player.masculin);
      player.toughness = element.getVariable('toughness').value;
      player.intelligence = element.getVariable('intelligence').value;
      player.leadership = element.getVariable('leadership').value;
      player.karma = element.getVariable('karma').value;
      player.tired = element.getVariable('tired').value;
      player.condition = element.getVariable('condition').value;
      this.timelineService.roomersListPlayers.push(player);

      //console.log('-roomer PLAYER', player.imageURL, player.outlook, player.strength, player.dexternity, player.initiative);
    }
  }


  closeModal()
  {
    this.modalCtrl.dismiss();
  }

  async onPlayerClick(player)
  {
    console.log('-onPlayerClick', player.userId);

    this.timelineService.showingAccount = this.timelineService.appReference.room.getUserByName(player.userId);

    console.log('onMsgClick', this.timelineService.showingAccount);
    
    if( this.timelineService.showingAccount==undefined) return;


    await this.presentAccountModal()
    const { data } = await this.modal.onWillDismiss();
    console.log('jaki czyn?',data);
    this.timelineService.showingAccount = null;

    if(data && data.fightStart==true)
    {
      console.log('walka, zamykamy')
      this.closeModal();
    }
  }

  async presentAccountModal() {
    this.modal = await this.modalController.create({
      component: AccountPage,
      cssClass: 'my-custom-class'
    });
    return await this.modal.present();
  }

}
